import { render, staticRenderFns } from "./medical-documents-table.vue?vue&type=template&id=3777475d&scoped=true&"
import script from "./medical-documents-table.vue?vue&type=script&lang=js&"
export * from "./medical-documents-table.vue?vue&type=script&lang=js&"
import style0 from "./medical-documents-table.vue?vue&type=style&index=0&id=3777475d&lang=scss&scoped=true&"
import style1 from "./medical-documents-table.vue?vue&type=style&index=1&id=3777475d&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3777475d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3777475d')) {
      api.createRecord('3777475d', component.options)
    } else {
      api.reload('3777475d', component.options)
    }
    module.hot.accept("./medical-documents-table.vue?vue&type=template&id=3777475d&scoped=true&", function () {
      api.rerender('3777475d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personal-employee/additions/medical-documents-table.vue"
export default component.exports